export default __webpack_public_path__ + "static/media/img_7.fc17ea4b.svg";